import {actions as A} from '../../constants/actions';

const showGlobalErrorMessage = (message, callback) => {
  return (dispatch) => {
    dispatch({
      type: A.SHOW_GLOBAL_ERROR_MESSAGE,
      payload: {message, callback}
    });
  }
};

export {showGlobalErrorMessage}
